import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { BASE_URL, DEFAULT_PARAM } from '../Contansts'
import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'

const useFetchFilteredData = (path, initialParams) => {
  const { language } = useLanguage()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [params, setParams] = useState(initialParams)
  const abortControllerRef = useRef(null)

  useEffect(() => {
    const url = `${BASE_URL}/${path}?${DEFAULT_PARAM}&locale=${language?.code || ''}&${params}`
    const fetchData = async () => {
      setLoading(true)
      setError(null)
      // Abort previous request if any
      if (abortControllerRef.current) {
        abortControllerRef.current.abort()
      }

      // Create a new abort controller
      abortControllerRef.current = new AbortController()

      try {
        const response = await axios.get(url, {
          signal: abortControllerRef.current.signal,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        setData(response.data)
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message)
        } else {
          setError({
            errorMessage:
              err?.response?.data?.error?.message || 'Something went wrong',
            hasError: true,
          })
        }
      } finally {
        setLoading(false)
      }
    }

    if (params) {
      fetchData()
    }

    // Cleanup function to abort request on unmount
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort()
      }
    }
  }, [path, params, language])

  return { data, loading, error, setParams }
}

export default useFetchFilteredData
